import React from 'react';
import { useSelector } from 'react-redux';
import { SubmitButton } from 'ui_system/forms/FormStyles';
import { t } from 'services/translation';

import {
  getAllStepsCompleted,
  getLinkColor,
  getExperienceUpdating,
} from 'data_system/resource_portal/selectors';

const FormSubmitButton = (props) => {
  const formCompleted = useSelector(getAllStepsCompleted);
  const brandColor = useSelector(getLinkColor);
  const updating = useSelector(getExperienceUpdating);
  const submitButtonText = formCompleted ? 'Save' : 'Next';

  return (
    <SubmitButton
      style={{ background: brandColor, borderColor: brandColor }}
      disabled={!props.dirty || updating}
      type="submit"
    >
      {t(submitButtonText)}
    </SubmitButton>
  );
};

export default FormSubmitButton;
